































































































































































































































import {
    EventBus,
    TypeEventBus,
    getUniqueId,
    addItemsToListIfAreNotAdded,
    removeItemsFromList
} from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import { MultipleSelect, MsgBox } from '../../core/components';
import SimpleTable from '../../core/components/SimpleTable.vue';
import TableArrows from '../../core/components/TableArrows.vue';
import Input from '../../core/components/Input.vue'; 
import Checkbox from '../../core/components/Checkbox.vue'; 
import multiselect from 'vue-multiselect';
import CreateUnityTypeAndVar from './CreateUnityTypeAndVar.vue';
import Sortable from 'sortablejs';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import { NormsServices } from '../../norms/api/NormsServices';

@Component({
    components: { 
        CreateUnityTypeAndVar, 
        MultipleSelect, 
        MsgBox, 
        TableArrows, 
        SimpleTable, 
        multiselect,
        Input,
        Checkbox 
    }
})
export default class VariableClassification extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() editing: boolean;
    @Prop() visible: boolean;
    @Prop() variableGroupToEdit: any;
    @Prop() variablesDefinitionFromSelectedVariableClassification: any;

    selectVehicle: any = null;
    vehicleOptions = ['Todas', 'Seleccionadas'];
    modalWidth: string = '1300';

    availableSelectedVariables: any[] = [];
    searchVariables: string = '';
    selectedVariables: any = [];
    searchIntoSelectedVariables: string = '';

    variableDefinitionList: any[] = [];

    description: string = '';

    searchVar: string = '';
    searchVarInGroup: string = '';

    availableVariablesSelected: any[] = [];

    searchavailableVariables: string = '';
    availableVehicles: Array<object> = [];
    loadingAvailableVariables: boolean = false;
    alarmable: boolean = false;

    selectedUnit: any = {};
    unitList: any[] = [];

    processingRequest: boolean = false;
    valid: boolean = false;

    visibleModalCreateUTV: boolean = false;
    editingUTV: boolean = false;
    patchDataUTV: any = {};
    actionModalUTV: string = '';
    unitySelected: any | null = null;

    get getAvailableVariablesSelected() {
        return this.availableVariablesSelected.length > 0;
    }

    get getSelectedVariables() {
        return this.availableSelectedVariables.length > 0;
    }

    updateAlarmableValue(value){
        this.alarmable = value;
    }
    updateAvailableVariablesSelected(value){
        this.availableVariablesSelected = value;
    }

    moveVariableToTheRight() {
        let self = this;
        //agrego el parametro calculado si no fue agregado a los calculados seleccionados
        const copyOfVariablesSelected = JSON.parse(JSON.stringify(this.selectedVariables));
        for (let i = 0; i < this.availableVariablesSelected.length; i++) {
            let variable = this.availableVariablesSelected[i];
            copyOfVariablesSelected.push(variable);
        }
        this.removeSelectedVariableFromMainList(this.availableVariablesSelected);
        this.selectedVariables = copyOfVariablesSelected;
        this.availableVariablesSelected = [];
    }

    removeSelectedVariableFromMainList(itemsToExclude) {
        for(let i=0; i<itemsToExclude.length; i++){
            let currentItemId = itemsToExclude[i]['id'];
            let indexInAvailableList = this.variableDefinitionList.findIndex(item => item['id'] == currentItemId);
            if(indexInAvailableList !== -1){
                this.variableDefinitionList.splice(indexInAvailableList, 1)
            }
        }
    }

    moveVariableToTheLeft() {
        const copyOfVariables = JSON.parse(JSON.stringify(this.variableDefinitionList));

        for (let i = 0; i < this.availableSelectedVariables.length; i++) {
            let itemToExclude = this.availableSelectedVariables[i];
            let index = this.selectedVariables.indexOf(itemToExclude);
            this.selectedVariables.splice(index, 1);
            copyOfVariables.push(itemToExclude);
        }
        this.variableDefinitionList = copyOfVariables;
        this.availableSelectedVariables = [];
    }

    get shouldCreateAndDeleteUnit(): boolean {
        return (
            this.$_checkPrivileges(PRIVILEGE_KEYS.NORMS, PRIVILEGE_TYPES.CREATE) ||
            this.$_checkPrivileges(PRIVILEGE_KEYS.NORMS, PRIVILEGE_TYPES.EDIT_AND_DELETE)
        );
    }

    get tableSelectedVariables(): HTMLFormElement {
        return this.$refs.tableSelVariables as HTMLFormElement;
    }

    initCalcVariablesDragDrop() {
        let vm = this;
        let table = this.tableSelectedVariables.$el.querySelector('tbody');
        const _self = this;
        Sortable.create(table, {
            handle: '.handle', // Use handle so user can select text
            onEnd({ newIndex, oldIndex }) {
                const rowSelected = _self.selectedVariables.splice(oldIndex, 1)[0]; // Get the selected row and remove it
                _self.selectedVariables.splice(newIndex, 0, rowSelected); // Move it to the new index
            }
        });
    }

    addNewUnity(newUnity) {
        this.unitList.push(newUnity);
        this.unitySelected = newUnity;
        this.$_successPatchRecipients('Unidad agregada');
    }

    visibilityModalCreateUTV(value) {
        this.visibleModalCreateUTV = value;
    }

    createUTV(action) {
        this.patchDataUTV = {};
        this.editingUTV = false;
        this.actionModalUTV = action;
        this.visibilityModalCreateUTV(true);
    }

    assignPatchUTVData(response) {
        let self = this;
        self.patchDataUTV = response;
        self.visibilityModalCreateUTV(true);
    }

    async getVariableDefinitionList() {
        this.loadingAvailableVariables = true;
        this.variableDefinitionList = await NormsServices.getVariableDefinitionList();
        if (this.editing) this.removeSelectedVariableFromMainList(this.selectedVariables);
        this.loadingAvailableVariables = false;
    }

    customItemClass(item) {
        return 'truncate-row';
    }

    get getVariablesDefinition() {
        return this.variableDefinitionList;
    }

    async getUnidadList() {
        let response = await NormsServices.getUnidadList();
        this.unitList = response;
    }

    get headersAvailableVariables() {
        return [
            {
                text: 'Variables',
                value: 'description',
                sortable: true
            }
        ];
    }

    get headersAvailableVariablesWithArrow() {
        return [
            {
                text: '',
                align: 'left',
                sortable: false,
                value: 'handle',
                class: 'short-column'
            },
            {
                text: 'Variables',
                value: 'description',
                sortable: true
            }
        ];
    }

    nameRules: any = [
        v => !!v || 'Debe ingresar la descripción',
        v => (v && v.length >= 1) || 'Debe ingresar la descripción'
    ];

    mounted() {
        if (this.editing) {
            this.$nextTick(() => {
                this.initCalcVariablesDragDrop();
            });
        }
        EventBus.$on(TypeEventBus.NORMS_VARIABLE_CLASSIFICATION_DIALOG_CLOSE_CHILDREN_COMPONENT, () => {
            this.visibleModalCreateUTV = false;
        });

        this.getUnidadList();
        this.getVariableDefinitionList();
        this.loadModalData();
    }

    updateDescription(value){
        this.description = value;
        this.sendDataToParent();
    }
    updateSearchVariables(value){
        this.searchVariables = value;
    }
    updateSearchIntoSelectedVariables(value){
        this.searchIntoSelectedVariables = value;
    }

    // @Watch('visible')
    loadModalData() {
        if (this.editing) {
            if (this.variableGroupToEdit !== null) {
                this.description = this.variableGroupToEdit.description;
                this.selectedUnit = this.variableGroupToEdit.unit;
                this.alarmable = this.variableGroupToEdit.alarmable;
                this.selectedVariables = this.variablesDefinitionFromSelectedVariableClassification || [];
            } else {
                this.description = '';
                this.selectedUnit = {};
                this.alarmable = false;
            }
        } else {
            this.description = '';
            this.selectedUnit = {};
            this.alarmable = false;
        }
    }

    submitVariableClassification() {
        this.sendDataToParent();
        if (!this.editing) {
            this.$emit('submitVariableClassification');
        } else {
            this.$emit('submitEditedVariableClassification');
        }
    }

    get canSaveVariableGroup() {
        return Boolean(this.description.length >= 1 && Object.keys(this.selectedUnit).length);
    }

    sendDataToParent() {
        if (this.selectedUnit) {
            let submitedData = {
                description: this.description.trim(),
                unit: this.selectedUnit.id,
                alarmable: this.alarmable,
                variable_definition_list: this.selectedVariables
            };
            this.$emit('submit', submitedData);
        }
    }

    @Emit()
    closeDialog(action: boolean, variableGroup: any) {}

    get unityTypeAndVarBreadcrums() {
        let breadcrumsOptions = [
            {
                text: 'Crear Variable Classification',
                disabled: false,
                href: '',
                active: false,
                action: 'goToCreateVarClassificationList'
            },
            {
                text: 'Crear Unidad',
                disabled: false,
                href: '',
                active: false,
                action: null
            }
        ];

        return breadcrumsOptions;
    }
}
